import { Dispatch, SetStateAction, useEffect, useState } from "react";

import { DataTable } from "iuvity-ui-components/dist/datatable";
import { Column } from "iuvity-ui-components/dist/column";
import { Checkbox } from "iuvity-ui-components";
import { IdataRoleResponse, RolePermission, IpermissionsToInsert, ImasterCategoryResponse } from "../../interfaces/roles.interface";
import { ORDER_PERMISSIONS } from "../../constants";
import { permissionTranslator } from "../../helpers/roleTypeTranslations";

interface TableFunctionalitiesProps {
    t: Function;
    dataCategory: any;
    subcategory: string;
    checkedValue: any;
    setCheckedValue: Function;
    permissionsList: string[];
    permissionsToInsert: IpermissionsToInsert[];
    setPermissionsToInsert: Dispatch<SetStateAction<IpermissionsToInsert[]>>;
    permissionsWithIDS: any;
    permissionsCounter: any;
    setPermissionsCounter: Dispatch<SetStateAction<number>>;
    setPermissionsChanged: Dispatch<SetStateAction<boolean>>;
    permissionsToInsertInitList: IpermissionsToInsert[];
    permissionsTypesListBK: ImasterCategoryResponse[];
    showTable: boolean;
    setActiveIndex: Dispatch<SetStateAction<number>>;
    dataRole?: IdataRoleResponse;
    checksDisable?: boolean;
}

export const TableFunctionalities: React.FC<TableFunctionalitiesProps> = ({
    t,
    dataCategory,
    subcategory,
    dataRole = undefined,
    checkedValue,
    setCheckedValue,
    permissionsList,
    permissionsToInsert,
    setPermissionsToInsert,
    permissionsWithIDS,
    permissionsCounter,
    setPermissionsCounter,
    checksDisable = false,
    setPermissionsChanged,
    permissionsToInsertInitList,
    permissionsTypesListBK,
    showTable,
    setActiveIndex
}) => {

    let orderPermissions = ORDER_PERMISSIONS;
    const auxPermissionsOrder = permissionsList.filter((permission:string) => !orderPermissions.includes(permission));
    orderPermissions = [ ...orderPermissions, ...auxPermissionsOrder ]
    // // CONSTRUCCIÓN DE OBJETO DE FUNCIONALIDADES CON LISTA DE PERMISOS
    // // PARA MOSTRAR LAS COLUMNAS RESPECTIVAS EN LA TABLA
    let permissionsObject = {};
    // eslint-disable-next-line array-callback-return
    permissionsList?.map((permission) => {
        permissionsObject = { ...permissionsObject, [permission]: false }
    });

    let funcionalitiesObject = {} as any;
    let functionalitiesAllCheckbox = {} as any;
    // eslint-disable-next-line array-callback-return
    (dataCategory.length > 0) && dataCategory.map((item:any) => {
        funcionalitiesObject = {
            ...funcionalitiesObject,
            [item.code]: {...permissionsObject}
        };

        functionalitiesAllCheckbox = {
            ...functionalitiesAllCheckbox,
            [subcategory]: {...permissionsObject}
        };
    });

    const [localCounter, setLocalCounter] = useState<number>(0);

    // // EFECTO PARA AGREGAR PROPIEDADES AL ESTADO GLOBAL
    // // DE ACUERDO A LOS PERMISOS DE FUNCIONALIDADES DE LA TABLA ACTUAL
    useEffect(()=>{
        setPermissionsCounter((prev:any)=>({
            ...prev,
            visited: {
                ...prev.visited,
                [subcategory]: true
            },
        }));


        if (!checkedValue.hasOwnProperty(Object.keys(funcionalitiesObject)[0])) {
            setCheckedValue((prev:any)=>({
                ...prev,
                ...funcionalitiesObject
            }));
        }

        // // CAMBIO DEL VALOR DE LOS PERMISOS DEL OBJETO DE FUNCIONALIDADES
        // // CONFORME A LOS PERMISOS QUE TRAE EL ROL (DE "FALSE" A "TRUE")
        // eslint-disable-next-line array-callback-return
        dataRole && dataRole.rolePermissions?.map((rolePermission: RolePermission) => {
            if (funcionalitiesObject.hasOwnProperty(rolePermission.functionality.code)) {
                funcionalitiesObject[rolePermission.functionality.code][rolePermission.permission.privilegeId] = true;
                permissionsCounter.hasOwnProperty('visited') && !permissionsCounter.visited[subcategory] && setLocalCounter((prev:number)=>( prev + 1 ));
            }
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(()=>{
        setPermissionsCounter((prev: any) => ({
            ...prev,
            [subcategory]: (prev[subcategory] || 0) + localCounter,
        }));
    },[localCounter, setPermissionsCounter, subcategory]);


    const [checkboxesAll, setCheckboxesAll] = useState(functionalitiesAllCheckbox);
    useEffect(()=>{
        // eslint-disable-next-line array-callback-return
        permissionsList.map((permission:string) => {
            setCheckboxesAll((prev:any)=>({
                ...prev,
                [subcategory]: {
                    ...prev[subcategory],
                    // eslint-disable-next-line array-callback-return
                    [permission]: !dataCategory.some((item: any) => {
                        if (checkedValue[item.code]?.hasOwnProperty(permission)) {
                            return checkedValue[item.code][permission] === false
                        }
                    }),
                }
            }));
        });
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[checkedValue]);

    useEffect(()=>{
        setActiveIndex( showTable ? 0 : 1 );
        !showTable && document.getElementById(`functionalities-accordion-multiple-${subcategory}_header_0`)?.click();
    },[setActiveIndex, showTable, subcategory]);

    return (
        showTable ?
            <div style={{ padding: '24px' }}>
                {
                    (permissionsList.length > 0) &&
                        <DataTable
                            dataKey={`table-${subcategory}`}
                            value={dataCategory?.map((functionalityItem: any) => ({
                                ...functionalityItem,
                                keyLabel: t(functionalityItem.keyLabel),
                            }))}
                            header={null}
                            paginator={false}
                            sortMode="single"
                            sortField="keyLabel"
                            sortOrder={1}
                        >
                            <Column field="keyLabel" header={t('Roles.functionalitiesLabel')}></Column>
                            {
                                permissionsList.sort((a: any, b: any) => {
                                    return orderPermissions.indexOf(a) - orderPermissions.indexOf(b);
                                })
                                .map((permission) => (
                                    <Column
                                        key={permission}
                                        header={
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <p style={{ marginBottom: "4px" }}>{permissionTranslator(t, permission, permissionsTypesListBK)}</p>
                                                <Checkbox
                                                    name={`${subcategory}-${permission}`}
                                                    checked={checkboxesAll[subcategory][permission]}
                                                    onChange={(e)=>{
                                                        let doIt:boolean = true;
                                                        if ( permission === 'READ' &&
                                                            !e.checked &&
                                                            permissionsList.filter((permissionId) => (
                                                                permissionId !== "READ" &&
                                                                checkboxesAll[subcategory][permissionId]
                                                            )).length > 0 ) doIt = false;
                                                        if (doIt) {
                                                            // eslint-disable-next-line array-callback-return
                                                            dataCategory.map((item:any, index:number) => {
                                                                if (e.checked !== checkedValue[item.code][permission]) {
                                                                    setTimeout(()=>{
                                                                        document.getElementsByName(`${item.code}-${permission}`).item(0).click();
                                                                    }, (index * 10));
                                                                }
                                                            });
                                                            setCheckboxesAll((prev:any)=>({
                                                                ...prev,
                                                                [subcategory]: {
                                                                    ...prev[subcategory],
                                                                    [permission]: !checkboxesAll[subcategory][permission],
                                                                }
                                                            }));
                                                        }
                                                    }}
                                                    disabled={checksDisable}
                                                />
                                            </div>
                                        }
                                        field="privilegeId"
                                        body={(option:any) => {
                                            return (checkedValue[option.code]?.hasOwnProperty(permission))
                                            ? (<div
                                                    key={`checkbox-${option.code}-${permission}`}
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Checkbox
                                                        key={`${option.code}-${permission}`}
                                                        id={`${option.code}-${permission}`}
                                                        name={`${option.code}-${permission}`}
                                                        checked={checkedValue[option.code][permission]}
                                                        onChange={(e)=>{
                                                            let doIt:boolean = true;
                                                            if ( permission !== 'READ'
                                                                && e.checked
                                                                && !checkedValue[option.code].READ ) {
                                                                    setTimeout(()=>{
                                                                        document.getElementsByName(`${option.code}-READ`).item(0).click();
                                                                    }, 50);
                                                            }
                                                            else {
                                                                if ( !e.checked &&
                                                                    permission === 'READ' &&
                                                                    permissionsList.filter((permissionId) => (
                                                                        permissionId !== "READ" &&
                                                                        checkedValue[option.code][permissionId]
                                                                    )).length > 0
                                                                ) doIt = false;
                                                            }
                                                            if (doIt) {
                                                                setCheckedValue((prev:any)=>({
                                                                    ...prev,
                                                                    [option.code]: {
                                                                        ...prev[option.code],
                                                                        [permission]: !checkedValue[option.code][permission],                                                    }
                                                                }));
                                                                setPermissionsCounter((prev:any) => ({
                                                                    ...prev,
                                                                    [subcategory]: prev[subcategory] + (e.checked ? 1 : -1),
                                                                }));
                                                                let auxPermissionsArray:IpermissionsToInsert[] = [];
                                                                if (!e.checked) {
                                                                    auxPermissionsArray = permissionsToInsert.filter((permissionItem: IpermissionsToInsert) => !(
                                                                        permissionItem.functionalityId === option.code &&
                                                                        permissionItem.permissionId === permissionsWithIDS[permission][option.code]
                                                                    ));
                                                                }
                                                                else {
                                                                    auxPermissionsArray = [
                                                                        ...permissionsToInsert,
                                                                        {
                                                                            functionalityId: option.code,
                                                                            permissionId: permissionsWithIDS[permission][option.code],
                                                                        }
                                                                    ];
                                                                }
                                                                setPermissionsToInsert(auxPermissionsArray);
                                                                let resultCompare:IpermissionsToInsert[] = [];
                                                                if (permissionsToInsertInitList.length === auxPermissionsArray.length) {
                                                                    // eslint-disable-next-line array-callback-return
                                                                    auxPermissionsArray.filter((a) => {
                                                                        // eslint-disable-next-line array-callback-return
                                                                        permissionsToInsertInitList.filter((p) => {
                                                                            if (a.functionalityId === p.functionalityId && a.permissionId === p.permissionId) {
                                                                                resultCompare.push(a)
                                                                            }
                                                                        })
                                                                    })
                                                                };
                                                                (
                                                                    (resultCompare.length !== auxPermissionsArray.length) ||
                                                                    (permissionsToInsertInitList.length !== auxPermissionsArray.length)
                                                                )
                                                                    ? setPermissionsChanged(true)
                                                                    : setPermissionsChanged(false);
                                                            }
                                                        }}
                                                        disabled={checksDisable}
                                                    />
                                                </div>)
                                            : null
                                            }}
                                        headerStyle={{width: '3em'}}
                                    />
                                ))
                            }
                        </DataTable>
                }
            </div>
        : null
    )
}
